export const MAX_QUANTITY = 99;
